module.exports = __webpack_public_path__ + "static/media/certyfikat-16.05866deb.png";